import { forwardRef } from "react";

const DatepickerInput = forwardRef(({ value, onClick, className }, ref) => (
    <button className={className} onClick={onClick} ref={ref}>
        {value}
    </button>
));

export default DatepickerInput;
